export default __webpack_public_path__ + "static/about-welder-12c4948ab0582999e689104097d9aada.jpg";